import { Injectable, OnDestroy } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root',
})
export class LoadingService implements OnDestroy {
  private static readonly SHOW_DELAY_MS = 200;
  private static readonly MIN_SHOW_MS = 300;

  private busyRequestCount = 0;
  private showTimer: ReturnType<typeof setTimeout> | null = null;
  private hideTimer: ReturnType<typeof setTimeout> | null = null;
  private spinnerVisible = false;
  private shownAt = 0;

  constructor(private spinnerService: NgxSpinnerService) {}

  busy(): void {
    this.busyRequestCount++;
    if (this.busyRequestCount > 1) {
      return;
    }

    this.cancelHideTimer();
    if (this.showTimer || this.spinnerVisible) {
      return;
    }
    this.showTimer = setTimeout(() => {
      this.showTimer = null;
      this.shownAt = Date.now();
      this.spinnerVisible = true;
      this.spinnerService.show();
    }, LoadingService.SHOW_DELAY_MS);
  }

  idle(): void {
    this.busyRequestCount--;
    if (this.busyRequestCount > 0) {
      return;
    }
    this.busyRequestCount = 0;

    if (this.showTimer) {
      clearTimeout(this.showTimer);
      this.showTimer = null;
      return;
    }
    if (!this.spinnerVisible) {
      return;
    }

    const elapsed = Date.now() - this.shownAt;
    const remainder = Math.max(0, LoadingService.MIN_SHOW_MS - elapsed);
    if (remainder === 0) {
      this.hideSpinnerNow();
    } else {
      this.cancelHideTimer();
      this.hideTimer = setTimeout(() => {
        this.hideTimer = null;
        this.hideSpinnerNow();
      }, remainder);
    }
  }

  ngOnDestroy(): void {
    if (this.showTimer) {
      clearTimeout(this.showTimer);
      this.showTimer = null;
    }
    this.cancelHideTimer();
  }

  private hideSpinnerNow(): void {
    this.spinnerVisible = false;
    this.shownAt = 0;
    this.spinnerService.hide();
  }

  private cancelHideTimer(): void {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
  }
}
